import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79ef9b1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=79ef9b1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ef9b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ef9b1c')) {
      api.createRecord('79ef9b1c', component.options)
    } else {
      api.reload('79ef9b1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=79ef9b1c&scoped=true", function () {
      api.rerender('79ef9b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system/addIdentity/index.vue"
export default component.exports